import Product from './Product';
export default class StaticProduct extends Product {
}
